import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from './constants';
import { getCompanyOwnedTools, getToolForOwner } from './companyOwnedToolsApi';

export const useToolsListForOwner = (companyId: string | undefined) =>
  useQuery({
    queryKey: [QUERY_KEYS.COMPANY_OWNED_TOOLS, companyId],
    queryFn: ({ signal }) => getCompanyOwnedTools(companyId!, { signal }),
    throwOnError: true,
    enabled: !!companyId,
    staleTime: 0,
  });

export const useToolForOwner = (toolId: string) =>
  useQuery({
    queryKey: [QUERY_KEYS.COMPANY_OWNED_TOOLS, toolId],
    queryFn: ({ signal }) => getToolForOwner(toolId, { signal }),
    throwOnError: true,
    staleTime: 0,
  });
